module.exports = __webpack_public_path__ + "static/media/2secondscreen.8fef942b.png";